import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { MODIFY_SOCIAL_SECURITY_FIELDS } from '../../services/personalInfoConstants'
import FileInput from '../../../../../components/fileInput/FileInput'
import Box from '@mui/material/Box'
import TextInput from '../../../../../components/form/TextInput'
import { ADD_BENEFICIARY_FIELDS } from '../../../beneficiary/services/modifyBeneficiaryConstants'
import { useFormState } from 'react-final-form'
import { Typography } from '@mui/material'

const ModifyPremiereMutuelle: React.FC = () => {
    const intl = useIntl()
    const { values } = useFormState()

    const filesCount = (values[MODIFY_SOCIAL_SECURITY_FIELDS.CERTIFICATE]?.length || 0)
    if (filesCount === 0) {
        values[ADD_BENEFICIARY_FIELDS.COMMENTAIRE] = ''
    }

    return (
        <>
            <Box flex="1">
                <Typography variant="body2">
                    <FormattedMessage id={'personalInfo.personalData.modifySS.textGerep'} values={{ br: <br /> }} />
                </Typography>
            </Box>
            <Box flex="1">
                <FileInput
                    name={MODIFY_SOCIAL_SECURITY_FIELDS.CERTIFICATE}
                    title={intl.formatMessage({ id: 'personalInfo.personalData.modifySS.titreRadiation' })}
                    required
                />
            </Box>
            {filesCount > 0 && <TextInput
                type="commentary"
                maxLength={197}
                maxWidth="unset"
                name={MODIFY_SOCIAL_SECURITY_FIELDS.COMMENTAIRE}
                label={intl.formatMessage({ id: 'sendContract.input.comment.label' })}
                helperText={intl.formatMessage({ id: 'sendContract.input.comment.helperText' })}
            />}
        </>
    )
}

export default ModifyPremiereMutuelle
